import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ContinueButton from "@components/ContinueButton";

const useStyles = makeStyles((theme) => ({
    ctaBox: {
        display: "flex",
        flexDirection: "column",
        width: "400px",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px 0px 13px 0px",
        padding: "20px 15px",

        [theme.breakpoints.down(380)]: {
            width: "300px",
        },
        [theme.breakpoints.between(380, 440)]: {
            width: "350px",
        },
        [theme.breakpoints.up(600)]: {
            flexDirection: "row",
        },
    },
    contentBox: {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    descriptionBox: {
        [theme.breakpoints.up(600)]: {
            flexDirection: "row",
        },
    },
}));

const SuccessCtaContainer = (props) => {
    const {
        link,
        name,
        title,
        description,
        buttonText,
    } = props;

    const styles = useStyles();

    // handler for CTA button
    const handleCTA = (e) => {
        window.location.href = link;
    };

    const ContentContainer = () => (
        <Box
            className={styles.contentBox}
        >
            <Typography
                variant="body2"
                component="h1"
                color="textPrimary"
                fontSize="12px"
                letterSpacing="-0.03px"
                style={{ textDecoration: "underline", fontWeight: "600" }}
            >
                {name}
            </Typography>
            <Box
                mt={2}
            >
                <Typography
                    variant="h6"
                    component="h1"
                    fontSize="18px"
                    style={{ fontWeight: "800" }}
                    letterSpacing ="-0.05px"
                >
                    {title}
                </Typography>
            </Box>
            <Box
                className={styles.descriptionBox}
                mt={2}
            >
                <Typography
                    variant="body2"
                    component="p"
                    style={{ lineHeight: 1.8, fontSize: "13px" }}
                >
                    {description}
                </Typography>
            </Box>
            <Box
                mt={4}
                mb={2}
            >
                <ContinueButton
                    text={buttonText}
                    onClick={handleCTA}
                    overrideWidth="100% !important"
                />
            </Box>
        </Box>
    );

    return (
        <Box
            className={styles.ctaBox}
            bgcolor={"#f3f4f6"}
        >
            <ContentContainer />
        </Box>
    );
};

export default SuccessCtaContainer;